module.exports = __webpack_public_path__ + "img/me-holding-baby.62de6ffb.png";